module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Use this function to inject a basic property into sizes based on a comparison function
 * All data prexisting in sizes will be availabe to the comparison function provided that
 * you inject it in the correct order in the Compose function.
 * @param {string} propName name of property to inject
 * @param {function} fn a function to do a comparison on values of sizes
 * @return {function} a wrapped react component
 */
var createBasicPropInjector = function createBasicPropInjector(name) {
  return function (fn) {
    return function (Wrapped) {
      return function (props) {
        return React.createElement(Wrapped, _extends({}, props, { sizes: _extends({}, props.sizes, _defineProperty({}, name, fn(props.sizes))) }));
      };
    };
  };
};

exports.default = createBasicPropInjector;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubPub = function SubPub() {
    var subscribers = {};

    var createKey = function createKey() {
        return Math.random().toString(16).slice(-8);
    };

    return Object.seal({
        subscribe: function subscribe(subscriber) {
            var key = createKey();
            subscribers[key] = subscriber;
            return { unsubscribe: function unsubscribe() {
                    return delete subscribers[key];
                } };
        },

        publish: function publish() {
            Object.keys(subscribers).map(function (key) {
                return subscribers[key]();
            });
        }
    });
};

var createListener = function createListener(eventType) {
    var listener = new SubPub();
    var working = false;

    window.addEventListener(eventType, function (e) {
        if (!working) {
            working = true;
            window.requestAnimationFrame(listener.publish);
            working = false;
            // setTimeout(() => (working = false), 66);
        }
    });

    return Object.seal({ subscribe: listener.subscribe });
};

/**
 * This function will inject one of our listeners (usually resize or scroll) in the sizes prop.
 * This will give the user access to subscribe to a window event.
 * @param {string} listener which listeners to inject into our sizes prop
 * @param {Component} Wrapped the component we are injecting into
 * @return {class} the wrapped component
 */
var createSubscriptionInjector = function createSubscriptionInjector(listener) {
    return function (Wrapped) {
        return function (_PureComponent) {
            _inherits(SubscribeListener, _PureComponent);

            function SubscribeListener(props) {
                _classCallCheck(this, SubscribeListener);

                var _this = _possibleConstructorReturn(this, (SubscribeListener.__proto__ || Object.getPrototypeOf(SubscribeListener)).call(this, props));

                _this.mergeStateAndProps = function () {
                    return _extends({}, _this.props.sizes, _defineProperty({}, listener, _this[listener]));
                };

                return _this;
            }

            /**
             * The injection will only happen after the component has mounted
             * this will prevent any calls to a global window object before it is present.
             * Therefore we must load the listener subscriptions asynchronously to support SSR
             */


            _createClass(SubscribeListener, [{
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this[listener] = createListener(listener);
                    this.forceUpdate();
                }
            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(Wrapped, _extends({}, this.props, { sizes: this.mergeStateAndProps() }));
                }
            }]);

            return SubscribeListener;
        }(_react.PureComponent);
    };
};

exports.default = createSubscriptionInjector;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Compose = __webpack_require__(5);

var _Compose2 = _interopRequireDefault(_Compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Compose2.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _smalldash = __webpack_require__(6);

var __ = _interopRequireWildcard(_smalldash);

var _injectors = __webpack_require__(7);

var _createBasicPropInjector = __webpack_require__(2);

var _createBasicPropInjector2 = _interopRequireDefault(_createBasicPropInjector);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var addOption = function addOption(option) {
    return function (bool) {
        return function (arr) {
            return bool ? [].concat(_toConsumableArray(arr), [option]) : arr;
        };
    };
};

var createCustomInjectors = function createCustomInjectors(arr) {
    return arr.map(function (injector) {
        return typeof injector.name === 'string' && typeof injector.fn === 'function' ? (0, _createBasicPropInjector2.default)(injector.name)(injector.fn) : undefined;
    }).filter(function (each) {
        return each !== undefined;
    });
};

var Compose = function Compose() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$component = _ref.component,
        component = _ref$component === undefined ? false : _ref$component,
        _ref$measureWindow = _ref.measureWindow,
        measureWindow = _ref$measureWindow === undefined ? false : _ref$measureWindow,
        _ref$inView = _ref.inView,
        inView = _ref$inView === undefined ? false : _ref$inView,
        _ref$mobile = _ref.mobile,
        mobile = _ref$mobile === undefined ? false : _ref$mobile,
        _ref$orientation = _ref.orientation,
        orientation = _ref$orientation === undefined ? false : _ref$orientation,
        _ref$breakpoint = _ref.breakpoint,
        breakpoint = _ref$breakpoint === undefined ? 768 : _ref$breakpoint,
        _ref$resizeWindow = _ref.resizeWindow,
        resizeWindow = _ref$resizeWindow === undefined ? false : _ref$resizeWindow,
        _ref$scrollWindow = _ref.scrollWindow,
        scrollWindow = _ref$scrollWindow === undefined ? false : _ref$scrollWindow,
        _ref$custom = _ref.custom,
        custom = _ref$custom === undefined ? [] : _ref$custom;

    return function (WrappedComponent) {
        // add measureWindow for props that depend on it
        measureWindow = inView || mobile || orientation ? true : measureWindow;
        // same with component boolean
        component = inView ? true : component;
        // same
        resizeWindow = measureWindow || component ? true : resizeWindow;

        var Wrappers = __.compose(addOption(_injectors.injectComponentSize)(component), addOption(_injectors.injectOrientation)(orientation), addOption((0, _injectors.injectMobile)(breakpoint))(mobile), addOption(_injectors.injectWindowSize)(measureWindow), addOption(_injectors.injectResizeSubscription)(resizeWindow), addOption(_injectors.injectScrollSubscription)(scrollWindow))([]);

        return __.compose.apply(__, _toConsumableArray(Wrappers).concat(_toConsumableArray(createCustomInjectors(custom)), [_injectors.injectCallback]))(WrappedComponent);
    };
};

exports.default = Compose;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("smalldash");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.injectScrollSubscription = exports.injectResizeSubscription = exports.injectOrientation = exports.injectMobile = exports.injectInView = exports.injectWindowSize = exports.injectComponentSize = exports.injectCallback = undefined;

var _injectComponentSize = __webpack_require__(8);

var _injectComponentSize2 = _interopRequireDefault(_injectComponentSize);

var _injectWindowSize = __webpack_require__(9);

var _injectWindowSize2 = _interopRequireDefault(_injectWindowSize);

var _injectInView = __webpack_require__(10);

var _injectInView2 = _interopRequireDefault(_injectInView);

var _injectMobile = __webpack_require__(11);

var _injectMobile2 = _interopRequireDefault(_injectMobile);

var _injectOrientation = __webpack_require__(12);

var _injectOrientation2 = _interopRequireDefault(_injectOrientation);

var _injectResizeSubscription = __webpack_require__(13);

var _injectResizeSubscription2 = _interopRequireDefault(_injectResizeSubscription);

var _injectScrollSubscription = __webpack_require__(14);

var _injectScrollSubscription2 = _interopRequireDefault(_injectScrollSubscription);

var _injectCallback = __webpack_require__(15);

var _injectCallback2 = _interopRequireDefault(_injectCallback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.injectCallback = _injectCallback2.default;
exports.injectComponentSize = _injectComponentSize2.default;
exports.injectWindowSize = _injectWindowSize2.default;
exports.injectInView = _injectInView2.default;
exports.injectMobile = _injectMobile2.default;
exports.injectOrientation = _injectOrientation2.default;
exports.injectResizeSubscription = _injectResizeSubscription2.default;
exports.injectScrollSubscription = _injectScrollSubscription2.default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MeasureComponent = function MeasureComponent(Wrapped) {
    /**
     * This is a component Action description
     */
    return function (_PureComponent) {
        _inherits(ComponentSize, _PureComponent);

        function ComponentSize() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, ComponentSize);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ComponentSize.__proto__ || Object.getPrototypeOf(ComponentSize)).call.apply(_ref, [this].concat(args))), _this), _this.getMeasurements = function () {
                var height = _this.DOMNode ? _this.DOMNode.clientHeight : 0;
                var width = _this.DOMNode ? _this.DOMNode.clientWidth : 0;
                return { height: height, width: width };
            }, _this.mergeSizes = function () {
                return _extends({}, _this.props.sizes, { component: _this.getMeasurements() });
            }, _this.onResize = function () {
                return _this.forceUpdate();
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        /**
         * on resize force an update.
         * do this instead of setting state because this component doesn't use the information
         */


        _createClass(ComponentSize, [{
            key: 'componentDidMount',


            /* Lifecycle */
            value: function componentDidMount() {
                // make sure to set reference to this node before attempting to size
                this.DOMNode = _reactDom2.default.findDOMNode(this);
            }

            /**
             * Lazily set up subscriptions to window object
             * @param {*} nextProps next props to receive from parent components
             */

        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.sizes.resize && !this.subscription) this.subscription = nextProps.sizes.resize.subscribe(this.onResize);
            }

            /**
             * Unsubscribe from window listener if it has been set up
             */

        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.subscription) this.subscription.unsubscribe();
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Wrapped, _extends({}, this.props, { sizes: this.mergeSizes() }));
            }
        }]);

        return ComponentSize;
    }(_react.PureComponent);
};

exports.default = MeasureComponent;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var injectWindowSize = function injectWindowSize(Wrapped) {
  return function (_React$PureComponent) {
    _inherits(WindowSize, _React$PureComponent);

    function WindowSize() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WindowSize);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WindowSize.__proto__ || Object.getPrototypeOf(WindowSize)).call.apply(_ref, [this].concat(args))), _this), _this.getMeasurements = function () {
        return {
          innerHeight: window.innerHeight,
          innerWidth: window.innerWidth,
          outerHeight: window.outerHeight,
          outerWidth: window.outerWidth
        };
      }, _this.mergeSizes = function () {
        return _extends({}, _this.props.sizes, { window: _this.getMeasurements() });
      }, _this.onResize = function () {
        return _this.forceUpdate();
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * Get measurements from the window object
     */


    /**
     * merge the size object with the new sizes
     */


    /**
     * on resize force an update.
     * do this instead of setting state because this component doesn't use the information
     */


    _createClass(WindowSize, [{
      key: 'componentDidMount',


      /**
       * Set a reference to the DOMNode
       */
      value: function componentDidMount() {
        this.DOMNode = _reactDom2.default.findDOMNode(this);
      }

      /**
       * Lazily set up subscriptions to window object
       * @param {*} nextProps next props to receive from parent components
       */

    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.sizes.resize && !this.subscription) this.subscription = nextProps.sizes.resize.subscribe(this.onResize);
      }

      /**
       * Unsubscribe from window listener if it has been set up
       */

    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.subscription) this.subscription.unsubscribe();
      }

      /**
       * Render the component with the new sizes object
       */

    }, {
      key: 'render',
      value: function render() {
        return React.createElement(Wrapped, _extends({}, this.props, { sizes: this.mergeSizes() }));
      }
    }]);

    return WindowSize;
  }(React.PureComponent);
};

exports.default = injectWindowSize;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function InView(Wrapped) {
	return function (_Component) {
		_inherits(InViewAction, _Component);

		function InViewAction(props) {
			_classCallCheck(this, InViewAction);

			var _this = _possibleConstructorReturn(this, (InViewAction.__proto__ || Object.getPrototypeOf(InViewAction)).call(this, props));

			_this.isInView = function () {
				var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    clientRect = _ref.clientRect,
				    windowSize = _ref.windowSize;

				var offsetTop = _this.DOMNode ? _this.DOMNode.offsetTop : undefined;

				return clientRect ? clientRect.top < 0 ? Math.abs(clientRect.top) - clientRect.height < 0 : clientRect.top < window.innerHeight : undefined;
			};

			_this.checkInView = function () {
				var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    sizes = _ref2.sizes;

				var inView = _this.isInView(sizes);
				inView !== _this.state.inView ? _this.setState({ inView: inView }) : null;
			};

			_this.mergeStateAndProps = function () {
				return _extends({}, _this.props.sizes, _this.state);
			};

			_this.state = {
				inView: undefined
			};
			return _this;
		}

		/* Check inView */


		/* Compare next inView to State */


		_createClass(InViewAction, [{
			key: 'componentDidMount',


			/* Lifecycle */
			value: function componentDidMount() {
				// make sure to set reference to this node before attempting to size
				this.DOMNode = _reactDom2.default.findDOMNode(this);
				this.checkInView(this.props);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.checkInView(nextProps);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(Wrapped, _extends({}, this.props, { sizes: this.mergeStateAndProps() }));
			}
		}]);

		return InViewAction;
	}(_react.Component);
}

exports.default = InView;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createMobileChecker = function createMobileChecker(breakpoint) {
	return function (sizes) {
		return sizes.window ? sizes.window.innerWidth < breakpoint : undefined;
	};
};

var IsMobile = function IsMobile(breakpoint) {
	return function (Wrapped) {
		var getMobile = createMobileChecker(breakpoint);

		return function (props) {
			return _react2.default.createElement(Wrapped, _extends({}, props, {
				sizes: _extends({}, props.sizes, { mobile: getMobile(props.sizes), breakpoint: breakpoint })
			}));
		};
	};
};

exports.default = IsMobile;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createBasicPropInjector = __webpack_require__(2);

var _createBasicPropInjector2 = _interopRequireDefault(_createBasicPropInjector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOrientation = function getOrientation(sizes) {
	return sizes.window ? sizes.window.innerWidth > sizes.window.innerHeight ? 'landscape' : 'portrait' : undefined;
};

exports.default = (0, _createBasicPropInjector2.default)('orientation')(getOrientation);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createSubscriptionInjector = __webpack_require__(3);

var _createSubscriptionInjector2 = _interopRequireDefault(_createSubscriptionInjector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSubscriptionInjector2.default)('resize');

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createSubscriptionInjector = __webpack_require__(3);

var _createSubscriptionInjector2 = _interopRequireDefault(_createSubscriptionInjector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSubscriptionInjector2.default)('scroll');

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This is the callback injection function. It uses react to make comparisons
 * @param {Component} Wrapped the component to wrap
 */
var CallBack = function CallBack(Wrapped) {
    var _class, _temp, _initialiseProps;

    return _temp = _class = function (_PureComponent) {
        _inherits(CallBackInjector, _PureComponent);

        function CallBackInjector(props) {
            _classCallCheck(this, CallBackInjector);

            var _this = _possibleConstructorReturn(this, (CallBackInjector.__proto__ || Object.getPrototypeOf(CallBackInjector)).call(this, props));

            _initialiseProps.call(_this);

            _this.state = {
                name: Wrapped.name,
                id: _this.props.id
            };
            return _this;
        }

        /* inject id and name for reference by parent function */


        /* debounce callback for component updates */


        _createClass(CallBackInjector, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.props.onSize) this.hotUpdate(this.props);
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (this.props.onSize && this.props !== nextProps) this.hotUpdate(nextProps);
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Wrapped, this.props);
            }
        }]);

        return CallBackInjector;
    }(_react.PureComponent), _initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.mergeStateAndNextProps = function (props) {
            return _extends({}, props.sizes, _this2.state);
        };

        this.hotUpdate = function (props) {
            _this2.props.onSize(_this2.mergeStateAndNextProps(props));
        };
    }, _temp;
};

exports.default = CallBack;

/***/ })
/******/ ]);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-size-components/build/index.js
// module id = 41
// module chunks = 3